'use strict';

var $ 		= require('jquery');
var assign 	= require('object-assign');

var classNames = {
	progressCircle: 'progress-circle'
};

var defaultOptions = {
	initialValue: 0,
	size: 120,
	strokeWidth: 10
};

function createSvg(options) {
	var svg	= document.createElementNS('http://www.w3.org/2000/svg', 'svg');

	svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	svg.setAttribute('version', '1.1');
	svg.setAttribute('width', options.size);
	svg.setAttribute('height', options.size);
	svg.setAttribute('viewPort', '0 0 ' + (options.size / 2) + ' ' + (options.size / 2));
	svg.setAttribute('class', $.getBemClass(classNames.progressCircle, 'rings'));

	return svg;
}

function createCircle(svgNS, options, elementClass) {
	var circle = document.createElementNS(svgNS, 'circle');
	var radius = (options.size / 2) - options.strokeWidth;
	var dashArray = Math.PI * (radius * 2);

	circle.setAttribute('r', radius);
	circle.setAttribute('cx', options.size / 2);
	circle.setAttribute('cy', options.size / 2);
	circle.setAttribute('fill', 'transparent');
	circle.setAttribute('stroke-dasharray', dashArray);
	circle.setAttribute('stroke-dashoffset', 0);
	circle.setAttribute('class', $.getBemClass(classNames.progressCircle, elementClass));

	return circle;
}

function setInnerRingOffset(value, $innerRing, $textDisplay) {
	if (isNaN(value) || value < 0) {
		value = 0; 
	} else if (value > 100) {
		value = 100;
	}

	var dashArray = Math.PI * ($innerRing.attr('r') * 2);
	var percent = ((100 - value) / 100) * dashArray;
	
	$innerRing.css({ strokeDashoffset: percent});
	$textDisplay.text(value + '%');
}

function initProgressCircle($progressCircle, options) {
	options = assign({}, defaultOptions, options); 

	if (!$progressCircle.hasBemClass(classNames.progressCircle)) {
		$progressCircle.addBemClass(classNames.progressCircle);
	}

	$progressCircle.css({
		width: options.size,
		height: options.size
	});

	var svg = createSvg(options);
	var outerRing = createCircle(svg.namespaceURI, options, 'rings__outer-ring');
	var innerRing = createCircle(svg.namespaceURI, options, 'rings__inner-ring');

	svg.appendChild(outerRing);
	svg.appendChild(innerRing);
	$progressCircle[0].appendChild(svg);	// SVGs must be appended using native DOM call to maintain namespaces

	var $textDisplay = $('<div />').addBemClass(classNames.progressCircle, 'text-display').css('top', options.size / 2);
	$progressCircle.append($textDisplay);

	$progressCircle.setProgress = function (value) {
		setInnerRingOffset(value, $(innerRing), $textDisplay);
	};

	$progressCircle.setProgress(options.initialValue);
}

module.exports = {
	init: function ($progressCircle, options) {
		if ($progressCircle.length > 0) {
			initProgressCircle($progressCircle, options);
		}

		return $progressCircle;
	}
};